/**
 * Sanitize user input text to prevent XSS when rendered or processed.
 * Strips HTML tags and escapes sensitive HTML characters.
 */
export function sanitizeText(input: string): string {
  if (!input) return "";
  return input
    .replace(/<[^>]*>/g, "")
    .replace(/[<>"'&]/g, (char) => {
      const entities: Record<string, string> = {
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "&": "&amp;",
      };
      return entities[char] || char;
    })
    .trim();
}

/**
 * Sanitize variable values used in prompt template substitution.
 */
export function sanitizePromptVariable(value: string): string {
  if (!value) return "";
  // Strip control characters and HTML tags
  return value.replace(/[\x00-\x1F\x7F]/g, "").replace(/<[^>]*>/g, "").trim();
}
